import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { request } from "@/utils/api";

// Create entity adapter
const creditNoteAdapter = createEntityAdapter({
    selectId: (creditNote) => creditNote._id, // Assuming each credit note has an _id field
    sortComparer: (a, b) => new Date(b.createdAt) - new Date(a.createdAt) // Sort by date descending
});

// Async thunk for fetching credit notes
export const fetchCreditNotes = createAsyncThunk(
    "creditNote/fetch",
    async ({ startDate, endDate }, { rejectWithValue }) => {
        try {
            const response = await request({
                endpoint: "/user/getCreditNote",
                method: "GET",
                params: { startDate, endDate },
            });

            console.log("Fetch Credit Notes API Response:", response || "No response");

            if (!response.success) {
                return rejectWithValue(response.message || "Failed to fetch credit notes.");
            }

            console.log("Fetched Credit Notes Data:", response.data || "No data"); // Debugging

            return response.data || {};
        } catch ({ error }) {
            console.error("Error fetching credit notes:", error.message);
            return rejectWithValue(error.message || "An unexpected error occurred.");
        }
    }
);

const initialState = creditNoteAdapter.getInitialState({
    loading: false,
    error: null,
});

const creditNoteSlice = createSlice({
    name: "creditNote",
    initialState,
    reducers: {
        clearCreditNotes: (state) => {
            creditNoteAdapter.removeAll(state);
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCreditNotes.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCreditNotes.fulfilled, (state, action) => {
                state.loading = false;
                creditNoteAdapter.setAll(state, action.payload);
            })
            .addCase(fetchCreditNotes.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

// Export the adapter selectors
export const {
    selectAll: selectAllCreditNotes,
    selectById: selectCreditNoteById,
    selectIds: selectCreditNoteIds,
} = creditNoteAdapter.getSelectors((state) => state.creditNote);

export const { clearCreditNotes } = creditNoteSlice.actions;
export default creditNoteSlice.reducer;
